<template>
    <div class="barcode-wrapper">
        <img :style="widthStyleObj" class="barcode" />
    </div>
</template>
  
<script>
import JsBarcode from 'jsbarcode'
export default {
    props: {
        JsBarcodeData: {
            type: Object,
        },
        
    }, 
    data(){
        return{
            widthStyleObj:{},
            barcodeSrc: ''
        }
    },
    mounted() {
        this.generateBarcode();
        // this.$nextTick(() => {
        //     JsBarcode('.barcode', String(this.JsBarcodeData.text), {     
        //          // format: "CODE39",//选择要使用的条形码类型 --  default: "auto" (CODE128)
        //           width:1.5,//设置条之间的宽度
        //           height:50,//高度
        //           displayValue:true ,//是否在条形码下方显示文字
        //           text:this.JsBarcodeData.bottomtext,//覆盖显示的文本
        //     //   fontOptions:"bold italic",//使文字加粗体或变斜体
        //     //   font:"fantasy",//设置文本的字体
        //     //   textAlign:"left",//设置文本的水平对齐方式
        //     //   textPosition:"top",//设置文本的垂直位置
        //     //   textMargin:5,//设置条形码和文本之间的间距
        //          fontSize:15,//设置文本的大小
        //          background: this.JsBarcodeData.background,//设置条形码的背景
        //          lineColor: this.JsBarcodeData.lineColor,//设置条和文本的颜色。
        //          margin:5//设置条形码周围的空白边距
        //     });
        // })
    },
    watch: {
      JsBarcodeData: {
        handler() {
          this.generateBarcode(); // 当 JsBarcodeData 属性变化时重新生成条形码
        },
        deep: true // 深度监听对象的变化
      }
    },
    methods: {
      generateBarcode() {
        JsBarcode('.barcode', String(this.JsBarcodeData.text), {
                 // format: "CODE39",//选择要使用的条形码类型 --  default: "auto" (CODE128)
                  width:1.5,//设置条之间的宽度
                  height:50,//高度
                  displayValue:true ,//是否在条形码下方显示文字
                  text:this.JsBarcodeData.bottomtext,//覆盖显示的文本
            //   fontOptions:"bold italic",//使文字加粗体或变斜体
            //   font:"fantasy",//设置文本的字体
            //   textAlign:"left",//设置文本的水平对齐方式
            //   textPosition:"top",//设置文本的垂直位置
            //   textMargin:5,//设置条形码和文本之间的间距
                 fontSize:15,//设置文本的大小
                 background: this.JsBarcodeData.background,//设置条形码的背景
                 lineColor: this.JsBarcodeData.lineColor,//设置条和文本的颜色。
                 margin:5//设置条形码周围的空白边距
        });
      // 获取条形码的 Base64 编码，并赋值给 barcodeSrc
        //this.barcodeSrc = document.querySelector('.barcode').toDataURL();
    }
  }
}
</script>
<style scoped>
.barcode-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
}
.barcode {
    max-width: 375px !important
}
</style>